var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3172 16.3C11.3172 17.7912 10.1084 19 8.61723 19C7.12606 19 5.91723 17.7912 5.91723 16.3M10.2341 4.8147C10.626 4.40978 10.8672 3.85806 10.8672 3.25C10.8672 2.00736 9.85987 1 8.61723 1C7.37459 1 6.36723 2.00736 6.36723 3.25C6.36723 3.85806 6.60843 4.40978 7.00038 4.8147M14.0172 9.28C14.0172 8.03879 13.4483 6.84841 12.4356 5.97074C11.4229 5.09307 10.0494 4.6 8.61723 4.6C7.18506 4.6 5.81155 5.09307 4.79885 5.97074C3.78616 6.84841 3.21723 8.03879 3.21723 9.28C3.21723 11.3336 2.70795 12.8355 2.07249 13.9102C1.34823 15.1351 0.986107 15.7475 1.00041 15.8938C1.01677 16.0611 1.04689 16.114 1.18264 16.2132C1.30128 16.3 1.89739 16.3 3.0896 16.3H14.1449C15.3371 16.3 15.9332 16.3 16.0518 16.2132C16.1876 16.114 16.2177 16.0611 16.2341 15.8938C16.2484 15.7475 15.8862 15.1351 15.162 13.9102C14.5265 12.8355 14.0172 11.3336 14.0172 9.28Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationManager);
export default __webpack_public_path__ + "static/media/Notification-manager.9592e7d27c85956f830a35423534b54f.svg";
export { ForwardRef as ReactComponent };